import { createAjv } from "@jsonforms/core";
import Drawer from "@mui/material/Drawer";
import { Button, Icon, LoadingSpinner } from "pepsico-ds";
import { useMemo } from "react";
import JsonFormsWrapper from "../../../jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import "./PartnerForm.scss";

const uiSchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      label: "Partner subtype",
      scope: "#/properties/type",
      rule: {
        effect: "DISABLE",
        condition: {
          scope: "#",
          schema: {},
        },
      },
    },
    {
      type: "Control",
      label: "Name",
      scope: "#/properties/name",
    },
    {
      type: "Control",
      label: "Description",
      scope: "#/properties/description",
      component: "textarea",
    },
    {
      type: "Control",
      label: "Active",
      scope: "#/properties/active",
      component: "toggle",
    },
  ],
};

const jsonSchema = {
  type: "object",
  properties: {
    type: {
      default: "PARTNER_CODE_GROUP",
      type: "string",
    },
    name: {
      type: "string",
      minLength: 3,
      maxLength: 255,
      description: "Please enter name",
    },
    description: {
      type: "string",
      minLength: 3,
      maxLength: 255,
      description: "Please enter description",
    },
    active: {
      type: "boolean",
      default: true,
    },
  },
  required: ["name", "description"],
};

function PartnerFormModal({
  isOpen,
  closeModal,
  partnerData,
  setPartnerData,
  handleMutation,
  loading,
  title,
  btnTitle,
}) {
  const ajvInstance = useMemo(() => {
    return createAjv();
  }, []);

  const isValidForm = ajvInstance.validate(jsonSchema, partnerData);

  const getUIschema = () => {
    const uiSchemaCopy = JSON.parse(JSON.stringify(uiSchema));

    const activeField = uiSchemaCopy.elements.find(
      (element) => element.scope === "#/properties/active"
    );

    if (activeField && partnerData?.isAttached) {
      activeField.readOnly = true;
    }

    return uiSchemaCopy;
  };

  return (
    <Drawer
      open={isOpen}
      onClose={closeModal}
      anchor="right"
      classes={{ paper: "partner-form-drawer" }}
    >
      <div className="partner-form-drawer-header">
        <h2 className="partner-form-drawer-title">{title}</h2>
        <button
          type="button"
          aria-label="Close"
          className="partner-form-close-button"
          onClick={closeModal}
        >
          <Icon icon="close" />
        </button>
      </div>
      <div className="partner-form-drawer-content">
        <JsonFormsWrapper
          jsonschema={jsonSchema}
          uischema={getUIschema()}
          data={partnerData}
          onChange={(data) => setPartnerData(data)}
        />
      </div>
      <div className="partner-form-drawer-footer">
        <Button
          size="medium"
          variant="primary"
          disabled={!isValidForm || loading}
          onClick={handleMutation}
        >
          {loading ? (
            <LoadingSpinner
              size={{ height: "24px", width: "24px" }}
              style={{ margin: "0 2.4rem" }}
            />
          ) : (
            <>{btnTitle || title}</>
          )}
        </Button>
      </div>
    </Drawer>
  );
}

export default PartnerFormModal;
